// app/javascript/controllers/users_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { path: String }

  connect() {
    // this.displayInsights();
    if (this.shouldDisableForm()) {
      this.disableForm();
    }
  }

  shouldDisableForm() {
    const currentPath = window.location.pathname;
    const isEditable = currentPath.includes("edit") || currentPath.includes("new");
    return !isEditable;
  }

  disableForm() {
    // const form = this.element.querySelector("form");
    // form.querySelectorAll("input, button").forEach((element) => {
    //   element.disabled = true;
    // });

    // form.querySelectorAll("select").forEach((element) => {
    //   element.disabled = true;
    // });

    // document.querySelectorAll(".user-action-buttons").forEach(function(element) {
    //   element.disabled = true;
    // });

    var form = document.getElementById("user_form");
    for (var i = 0; i < form.elements.length; i++) {
      form.elements[i].disabled = true;
    }

    document.querySelectorAll('.user-action-buttons').forEach(function(element) {
      element.classList.add('d-none');
    });
  }

  displayInsights() {
    console.log("Hello, Stimulus!", this.element)
    console.log("Current path:", this.pathValue);
    console.log("Current path:", this.currentPath);
  }

}
